import {_utils} from "../../utils/_utils.js";
import {initCardsSlider} from "../../utils/cards-slider.js";

/**
 * Cards carousel — "Six pillars of confidence" (Single service, TZ section 4):
 * → moves one card forward, ← one back (see utils/cards-slider.js). Gap: 32px mobile, 64px desktop.
 */
export const cardsCarousel = () => {
    return new Promise((resolve) => {
        _utils.initSection('.cards-carousel', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const slider = section.querySelector('.cards-carousel__slider');
    if (!slider) return;

    initCardsSlider(
        slider,
        section.querySelector('.cards-carousel__nav-btn--prev'),
        section.querySelector('.cards-carousel__nav-btn--next'),
        {
            spaceBetween: 32,
            breakpoints: {
                1025: {spaceBetween: 64},
            },
        }
    );
};
